import React from "react";

const SkeletonBlock = ({ width, height, borderRadius, style }) => (
  <div
    className="skeleton-shimmer"
    style={{ width, height, borderRadius, ...style }}
  />
);

const SkeletonDetailRow = () => (
  <div className="user-detail-row">
    <div className="user-details-label">
      <SkeletonBlock width={16} height={16} borderRadius={4} />
      <SkeletonBlock width={80} height={14} borderRadius={4} />
    </div>
    <SkeletonBlock width={120} height={14} borderRadius={4} />
  </div>
);

const UserBasicInfoCardSkeleton = () => (
  <div className="user-info-card">
    <div className="user-info-header">
      <SkeletonBlock width={120} height={20} borderRadius={4} />
      <SkeletonBlock width={180} height={36} borderRadius={20} />
    </div>
    <hr className="user-info-divider" />
    <div className="user-info-content">
      <div className="user-avatar-container">
        <SkeletonBlock width="100%" height="100%" borderRadius="50%" />
      </div>
      <div className="user-details">
        <div className="user-details-column">
          {Array.from({ length: 4 }).map((_, i) => (
            <SkeletonDetailRow key={i} />
          ))}
        </div>
        <div className="user-details-column-divider" />
        <div className="user-details-column">
          {Array.from({ length: 3 }).map((_, i) => (
            <SkeletonDetailRow key={i} />
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default UserBasicInfoCardSkeleton;
